export const WORK_ORDER_CATEGORIES = {
    CATEGORY_PRIMARY: 'primary',
    CATEGORY_SECONDARY: 'secondary',
    CATEGORY_STUDENT: 'student'
};